import React from 'react'
import stylesC from '../../styles/common.module.css';

interface SectionTitleProps {
    title: String;
    titleEng: String;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, titleEng }) => {
    return (
        <div className={stylesC.titleS}>
            <span></span>
            <h2>
                {title}
            </h2>
            <span className={stylesC.content}>
                {titleEng}
            </span>
        </div>
    )
}

export default SectionTitle;
